import { CALL_API, Schemas } from '../../../common/middleware/api';

export const FINANCIAL_REPORT_REQUEST = 'FINANCIAL_REPORT_REQUEST';
export const FINANCIAL_REPORT_SUCCESS = 'FINANCIAL_REPORT_SUCCESS';
export const FINANCIAL_REPORT_FAILURE = 'FINANCIAL_REPORT_FAILURE';


export const SCHOOL_YEARS_REQUEST = 'SCHOOL_YEARS_REQUEST';
export const SCHOOL_YEARS_SUCCESS = 'SCHOOL_YEARS_SUCCESS';
export const SCHOOL_YEARS_FAILURE = 'SCHOOL_YEARS_FAILURE';

export const financialReport = (options, onSuccessEvent) =>({
	[CALL_API]: {
		types: [FINANCIAL_REPORT_REQUEST, FINANCIAL_REPORT_SUCCESS, FINANCIAL_REPORT_FAILURE],
		endpoint: `api/reports/financialReport`,
		request: options,
		onSuccessEvent
	}
});


export const loadSchoolYears = (options) => ({
	[CALL_API]: {
		types: [SCHOOL_YEARS_REQUEST, SCHOOL_YEARS_SUCCESS, SCHOOL_YEARS_FAILURE],
		endpoint: `api/terms/schoolYears`,
		request: options,
		schema: Schemas.SCHOOL_YEARS_ARRAY
	}
});
